//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CLL_IPI',
  data() {
    return {
      form: {
        age: '',
        item1: '',
        item2: '',
        item3: '',
        item4: '',
      },
      ageList: [
        { value: '0', name: '≤65' },
        { value: '1', name: '>65' },
      ],
      item1List: [
        { value: '0', name: 'Binet A or Rai 0' },
        { value: '1', name: 'Binet B-C or Rai I-IV' },
      ],
      item2List: [
        { value: '0', name: '≤3.5' },
        { value: '2', name: '>3.5' },
      ],
      item3List: [
        { value: '0', name: '突变' },
        { value: '2', name: '未突变' },
      ],
      item4List: [
        { value: '0', name: '无异常' },
        { value: '4', name: '缺失17p (FISH)和/或TP53突变' },
      ],
      hasScore: false,
      disabled: false,
      text1: '',
      text2: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result = form.age + form.item1 + form.item2 + form.item3 + form.item4
        self.hasScore = true
        if (result < 2) {
          self.text1 = '低危'
          self.text2 = '5年生存率93.2%'
        } else if (result < 4) {
          self.text1 = '中危'
          self.text2 = '5年生存率79.4%'
        } else if (result < 7) {
          self.text1 = '高危'
          self.text2 = '5年生存率63.6%'
        } else if (result < 11) {
          self.text1 = '极高危'
          self.text2 = '5年生存率23.3%'
        }
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/CLL_IPI.vue